import { SearchEmptyState } from '@apeiron/temp'
import { styled } from '@mui/material'

const ListEmptyState = styled(SearchEmptyState)`
  color: #b1b3b3;

  .Custom-Search-Empty-description {
    color: #ffffff;
  }
`

export default ListEmptyState
